//PrimeReact
import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"

//Appointments utils
import { formatOrgCalDate } from "./utils"

export default function AppointmentsTableDeclined({
  declinedAppointments,
  GetParticipantColumnBody,
}) {
  return (
    <DataTable
      value={declinedAppointments}
      sortField="startDateTime"
      sortOrder={1}
    >
      <Column
        field="startDateTime"
        sortable
        header="Date"
        body={formatOrgCalDate}
      />
      <Column field="engagementType" sortable header="Engagement Type" />
      <Column
        field="engagementChannel"
        sortable
        bodyStyle={{ textTransform: "capitalize" }}
        header="Engagement Channel"
        body={(rowData) => {
          if (rowData.cron == null) {
            return rowData.engagementChannel
          } else {
            return rowData.engagementChannel + " | Recurring"
          }
        }}
      />
      <Column field="scheduledTime" sortable header="Scheduled Time" />
      {!!GetParticipantColumnBody ? (
        <Column
          body={GetParticipantColumnBody}
          field="participantName"
          sortable
          header="Participant"
        />
      ) : null}
      <Column field="type" sortable header="Request type" />
    </DataTable>
  )
}
